<div mat-dialog-title>{{data.title}}</div>
<div mat-dialog-content>

    <div class="dialog-description pb-4">{{ data.message }}</div>
</div>